module.exports = __webpack_public_path__ + "media/images/icons/outlined/cloud-server-e592891641ff9e588c91d3f69e0e4f3b.svg";